export * from './format';

/**
 * 获取当前时间戳，ms单位
 */
export function now() {
    return (Date.now && Date.now()) || new Date().getTime();
}
